import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button, Typography, Space, Layout } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import './accessDenied.scss'
import accessDenied from '../../assets/images/accessDenied.png'

const { Paragraph } = Typography
const { Content } = Layout

const AccessDenied = () => {
  const navigate = useNavigate()

  React.useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'auto'
    }
  }, [])

  return (
    <Layout className="access-denied-container">
      <Content className="access-denied-content">
        <div className="custom-result">
          <img
            src={accessDenied}
            alt="Access denied"
            className="accessDeniedImage"
            style={{ maxWidth: '500px', maxHeight: '350px', width: 'auto', height: 'auto' }}
          />
          <h1 className="result-title">Access Denied</h1>
          <div className="result-subtitle">You don't have permission to access this page.</div>
          <div className="result-extra">
            <Space direction="vertical" align="center">
              <Paragraph>
                You are not authorized to view this content. Please contact your administrator if you believe this is an error.
              </Paragraph>
              <Button
                type="primary"
                icon={<HomeOutlined />}
                size="large"
                onClick={() => navigate('/home')}
                className="access-denied-button"
              >
                Back to Home
              </Button>
            </Space>
          </div>
        </div>
      </Content>
    </Layout>
  )
}

export default AccessDenied